export default __webpack_public_path__ + "static/media/ikross.45680631.png";